import { render } from "./AppHeroSlider.vue?vue&type=template&id=d344da04&scoped=true"
import script from "./AppHeroSlider.vue?vue&type=script&lang=js"
export * from "./AppHeroSlider.vue?vue&type=script&lang=js"

import "./AppHeroSlider.vue?vue&type=style&index=0&id=d344da04&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d344da04"]])

export default __exports__